import { databases } from "@/lib/appwrite";
import { ID } from "appwrite";

const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
const collectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

// ─── createWorkerProfile ───────────────────────────────────────────────────────
export const createWorkerProfile = async ({
  userId,
  // Nombre separado
  firstName,
  middleName,
  lastName,
  secondLastName,
  // Auth / acceso
  email,
  // Datos personales
  birthday,
  bloodType,
  colabDniCode,
  phone1,
  phone2,
  emergencyContact,
  address,
  // Datos corporativos
  joinDate,
  rolCorp,
  occupation,
  occupationAbbreviation,
  colabCorpCode,
  area,
  idSupervisor,
  departmentId,
  // Datos bancarios
  bank,
  bankAccountNumber,
  bankAccountType,
  // Otros
  keyFunctions,
  archievements,
}: {
  userId: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  secondLastName?: string;
  email: string;
  birthday: string;
  bloodType: string;
  colabDniCode: string;
  phone1: string;
  phone2: string;
  emergencyContact: string;
  address: string;
  joinDate: string;
  rolCorp: string;
  occupation: string;
  occupationAbbreviation: string;
  colabCorpCode: string;
  area: string;
  idSupervisor: string;
  departmentId: string;
  bank: string;
  bankAccountNumber: string;
  bankAccountType: string;
  keyFunctions: string;
  archievements: string;
}) => {
  return await databases.createDocument(databaseId, collectionId, ID.unique(), {
    userId,
    firstName,
    middleName: middleName || "",
    lastName,
    secondLastName: secondLastName || "",
    email,
    birthday,
    bloodType,
    colabDniCode,
    phone1,
    phone2,
    emergencyContact,
    address,
    joinDate,
    rolCorp,
    occupation,
    occupationAbbreviation,
    colabCorpCode,
    area,
    idSupervisor,
    departmentId,
    bank,
    bankAccountNumber,
    bankAccountType,
    keyFunctions,
    archievements,
  });
};